import { Button, DialogContent, Stack, Typography } from "@mui/material";
import type { JSX } from "react";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import BackdropLoader from "@entrilia/shared/components/fullScreenLoader/BackdropLoader";
import SmallDialog from "@entrilia/shared/components/SmallDialog";

export interface InfoDialogData {
  title: string;
  description?: string;
  icon?: JSX.Element;
}

interface Props {
  data: InfoDialogData | undefined;
  onClose: () => void;
  isLoading?: boolean;
}

const InfoDialog = ({ data, onClose, isLoading }: Props) => {
  const { title, description, icon } = data || {};

  return (
    <SmallDialog open={!!data} scroll="paper" onClose={onClose}>
      <DialogContent sx={{ pt: 6 }}>
        <Stack spacing={2} sx={{ alignItems: "center", justifyContent: "center" }}>
          {icon}
          <Stack spacing={1} sx={{ alignItems: "center", justifyContent: "center" }}>
            <Typography variant="h6">{title}</Typography>
            {description && (
              <Typography color="textSecondary" sx={{ textAlign: "center" }}>
                {description}
              </Typography>
            )}
          </Stack>
        </Stack>
      </DialogContent>
      <DialogButtons>
        <Button variant="contained" color="primary" onClick={onClose}>
          Close
        </Button>
      </DialogButtons>
      <BackdropLoader open={!!isLoading} />
    </SmallDialog>
  );
};

export default InfoDialog;
